import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const UploadDoc = () => {
  const [formData, setFormData] = useState({
    title: "",
    firmName: "",
    issueDate: "",
    expiryDate: "",
    concernPersonName: "",
    concernPersonPhone: "",
    file: null,
  });

  const [firms, setFirms] = useState([]);
  const [loadingFirms, setLoadingFirms] = useState(true);

  useEffect(() => {
    fetchFirms();
  }, []);

  const fetchFirms = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/api/get-firms`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setFirms(res.data.firms || []);
    } catch (err) {
      console.error("Error fetching firms:", err.message);
    } finally {
      setLoadingFirms(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, file: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.firmName) {
      Swal.fire("Error", "Please select a firm name", "warning");
      return;
    }

    const data = new FormData();

    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      Swal.fire("Error", "User data not found", "error");
      return;
    }

    Object.keys(formData).forEach((key) => {
      data.append(key, formData[key]);
    });

    data.append("userData", JSON.stringify(user));

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/add-doc`, data, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      Swal.fire("Success", "Document uploaded successfully!", "success");
      setFormData({
        title: "",
        firmName: "",
        issueDate: "",
        expiryDate: "",
        concernPersonName: "",
        concernPersonPhone: "",
        file: null,
      });
    } catch (error) {
      Swal.fire("Error", "Failed to upload document", "error");
      console.error(error.message);
    }
  };

  return (
    <div className="card shadow-lg p-4 bg-light">
      <h2 className="text-primary text-center mb-2">Upload Document</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Title:</label>
          <input
            type="text"
            name="title"
            className="form-control"
            placeholder="Title"
            onChange={handleChange}
            required
          />
        </div>

        <div className="mb-3">
          <label className="form-label">Firm Name:</label>
          {loadingFirms ? (
            <p className="text-muted">Loading firms...</p>
          ) : firms.length === 0 ? (
            <p className="text-danger">No firms available</p>
          ) : (
            <select
              name="firmName"
              className="form-select"
              onChange={handleChange}
              value={formData.firmName}
              required
            >
              <option value="">-- Select Firm --</option>
              {firms.map((firm) => (
                <option key={firm._id} value={firm.firmName}>
                  {firm.firmName}
                </option>
              ))}
            </select>
          )}
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Issue Date</label>
            <input
              type="date"
              name="issueDate"
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Expiry Date</label>
            <input
              type="date"
              name="expiryDate"
              className="form-control"
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Concern Person Name:</label>
            <input
              type="text"
              name="concernPersonName"
              className="form-control"
              placeholder="Concern Person Name"
              onChange={handleChange}
              required
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Concern Person Number:</label>
            <input
              type="text"
              name="concernPersonPhone"
              className="form-control"
              placeholder="Phone Number"
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="mb-3">
          <input
            type="file"
            name="file"
            className="form-control"
            onChange={handleFileChange}
            accept="application/pdf"
            required
          />
        </div>
        <button type="submit" className="btn btn-outline-success w-100 fw-bold">
          Upload Document
        </button>
      </form>
    </div>
  );
};

export default UploadDoc;
